export default __webpack_public_path__ + "static/video-bg-1fb4ab46d630f276c3dc9590fef6b1ac.png";